export const DEFAULT_TIMEZONE = 'EST';

export const MEETING_URL_NULL_ERROR_MESSAGE = 'There isn’t a call link for this test session';

export const MODALS = {
  remove: 'REMOVE_TEST_SESSION_MODAL',
  editStatus: 'EDIT_TEST_SESSION_STATUS_MODAL',
};
